import { render, staticRenderFns } from "./FirmNewPP.vue?vue&type=template&id=247c30f0&scoped=true"
import script from "./FirmNewPP.vue?vue&type=script&lang=js"
export * from "./FirmNewPP.vue?vue&type=script&lang=js"
import style0 from "./FirmNewPP.vue?vue&type=style&index=0&id=247c30f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c30f0",
  null
  
)

export default component.exports